/**
 * Drops the keys Sitecore sent empty, so a default can stand in for them.
 *
 * A plain spread treats `""` as a supplied value and lets it win, which is
 * how an unfilled field ends up erasing copy the bundle already had — and in
 * one case took a whole panel off the page, because a group with no title
 * does not render. Unfilled and unsent now mean the same thing.
 *
 * Empty lists are kept. `[]` is a real answer — no suggested terms, no
 * filters — and must not be mistaken for a field nobody got to.
 *
 *   const labels = { ...DEFAULT_LABELS, ...withoutEmptyLabels(supplied) };
 */
export function withoutEmptyLabels<T extends object>(supplied: T): Partial<T> {
  const next: Record<string, unknown> = {};

  Object.keys(supplied).forEach((key) => {
    const value = (supplied as Record<string, unknown>)[key];

    if (value === null || value === undefined) {
      return;
    }

    if (typeof value === "string" && !value.trim()) {
      return;
    }

    next[key] = value;
  });

  return next as Partial<T>;
}
